export function scrollToFragment(options = {}) {
    stopScrollToFragment();
    getElement = options.getElement || getElementById;
    history = options.history;
    scrollIntoView = options.scrollIntoView || defaultScrollIntoView;
    startScrollToFragment();
}
function startScrollToFragment() {
    documentObserver = new MutationObserver(handleDomMutation);
    addEventListener("click", handleDocumentClick);
    unlistenHistory = history === null || history === void 0 ? void 0 : history.listen(handleHistoryPush);
    startObserving();
}
export function stopScrollToFragment() {
    stopObserving();
    removeEventListener("click", handleDocumentClick);
    if (unlistenHistory)
        unlistenHistory();
    unlistenHistory = undefined;
    documentObserver = undefined;
}
function startObserving() {
    stopObserving();
    if (!getLocation().hash)
        return;
    STOP_EVENTS.forEach(addStopListener);
    documentObserver === null || documentObserver === void 0 ? void 0 : documentObserver.observe(document, OBSERVER_CONFIG);
    adjustScrollPosition();
    observeTimeout = setTimeout(stopObserving, OBSERVE_TIMEOUT_MS);
}
function stopObserving() {
    clearTimeout(observeTimeout);
    cancelAnimationFrame(throttleRequestId);
    documentObserver === null || documentObserver === void 0 ? void 0 : documentObserver.disconnect();
    STOP_EVENTS.forEach(removeStopListener);
}
function addStopListener(eventName) {
    document.addEventListener(eventName, stopObserving);
}
function removeStopListener(eventName) {
    document.removeEventListener(eventName, stopObserving);
}
function handleHistoryPush(update, action) {
    if ("PUSH" === (action || update.action))
        startObserving();
}
function handleDocumentClick(event) {
    if (event.defaultPrevented)
        return;
    const anchor = closestAIncludingSelf(event.target);
    if (!anchor || !anchor.hash)
        return;
    if (anchor.pathname === getLocation().pathname)
        throttle(startObserving);
}
function closestAIncludingSelf(element) {
    let target = element;
    while (target && target.nodeName !== "A")
        target = target.parentElement;
    return target;
}
function handleDomMutation() {
    throttle(adjustScrollPosition);
}
function adjustScrollPosition() {
    const hash = getLocation().hash;
    if (!hash)
        return;
    const fragmentId = decodeURIComponent(hash.substring(1));
    const element = getElement.call(null, fragmentId);
    if (element)
        scrollIntoView.call(null, element);
}
function getLocation() {
    return (history === null || history === void 0 ? void 0 : history.location) || location;
}
function getElementById(id) {
    return document.getElementById(id);
}
function defaultScrollIntoView(element) {
    element.scrollIntoView();
}
function throttle(callback) {
    cancelAnimationFrame(throttleRequestId);
    throttleRequestId = requestAnimationFrame(callback);
}
let getElement;
let history;
let scrollIntoView;
let unlistenHistory;
let documentObserver;
let observeTimeout;
let throttleRequestId;
const OBSERVER_CONFIG = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
};
const OBSERVE_TIMEOUT_MS = 10000;
const STOP_EVENTS = ["selectstart", "touchend", "wheel"];
//# sourceMappingURL=index.js.map